<template>
    <div class="header_alram d4k-visible">
        <div class="hd_today">
            <p class="date">{{ today }}</p>
            <p class="time">{{ nowTime }}</p>
        </div>

        <div class="hd_weather">
            <ul>
                <li class="we01">
                    <span class="weather_temp">{{ airSpace.t1hValue }}</span> ℃
                    <span class="weather_sts">{{ airSpace.forecastText }}</span>
                </li>
                <li class="we03">미세먼지
                    <span :class="pm10Level[0]">{{ pm10Level[1] }}</span>
                </li>
                <li class="we03">초미세먼지
                    <span :class="pm25Level[0]">{{ pm25Level[1] }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import airLevel from "@/libs/air.level.js";

export default {
    data(){
        return {
            today: '',
            nowTime: '',
            airColorMap: {
                good: '#158afa',
                normal: '#14b515',
                bad: '#e88350',
                worse: '#e57373',
            },
        }
    },
    computed: {
        ...mapGetters({
            airSpace: 'getAirSpace',
            airGu: 'getAirGu',
            airHjdSensorList: 'getAirHjdSensorList',
        }),
        pm10Level: function() {
            let airCount = 0;
            let airSum = 0;
            this.airHjdSensorList.forEach(function(air){
                if(!isNaN(air.fineDust)) {
                    airCount++;
                    airSum += Number(air.fineDust);
                }
            });
            return airLevel.pm10Level(airSum / airCount);
        },

        pm25Level: function() {
            let airCount = 0;
            let airSum = 0;
            this.airHjdSensorList.forEach(function(air){
                if(!isNaN(air.ultraFineDust)) {
                    airCount++;
                    airSum += Number(air.ultraFineDust);
                }
            });
            return airLevel.pm25Level(airSum / airCount);
        },
    },
    created() {
        this.setTime();
        setInterval(function() {
            this.setTime();
        }.bind(this), 1000 * 30);

        this.$store.dispatch('FETCH_AIR_HJD_SENSOR_LIST');
        setInterval(function() {
            this.$store.dispatch('FETCH_AIR_HJD_SENSOR_LIST');
        }.bind(this), 1000 * 60 * 10);

    },
    methods: {
        setTime: function() {
            let date = new Date();
            this.today = date.format("yyyy년 MM월 dd일");
            this.nowTime = date.format("HH:mm");
        }
    },
};
</script>
